import { ManualGasXTransfert } from '@core/models/manual-gasx-transfert.model';
import { createReducer, on } from '@ngrx/store';

import { ExportGasXSelectionMode } from '../models/selection-mode.model';

import * as ExportGasXActions from './export-gasx.actions';

export const exportGasXFeatureKey = 'export-gasx';

export interface State {
  manualGasXTransfert: ManualGasXTransfert;
  selectionMode: ExportGasXSelectionMode;
  selectedObjects: Array<string>;
}

const initialState: State = {
  manualGasXTransfert: null,
  selectionMode: null,
  selectedObjects: []
};

export const reducer = createReducer(
  initialState,
  on(
    ExportGasXActions.initDataSuccess,
    ExportGasXActions.updateLatestManualGasXTransfert,
    (state, { manualGasXTransfert }) => ({
      ...state,
      manualGasXTransfert
    })
  ),
  on(ExportGasXActions.switchSelectionMode, (state, { selectionMode }) => ({
    ...state,
    selectionMode,
    selectedObjects: selectionMode === 'ALL' ? [] : state.selectedObjects
  })),
  on(ExportGasXActions.setSelectedObjects, (state, { selectedObjects }) => ({
    ...state,
    selectedObjects
  })),
  on(
    ExportGasXActions.resetState,
    ExportGasXActions.cancelManualGasXTransfertSuccess,
    ExportGasXActions.manualGasXTransfertSuccess,
    state => ({
      ...initialState,
      manualGasXTransfert: state.manualGasXTransfert
    })
  )
);
